var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star-rating"},_vm._l((5),function(n){return _c('img',{key:n,staticClass:"w-6 mx-1",attrs:{"src":require(("../../assets/img/" + (n <= _vm.score ? 'full-star.png' : 'star-empty.png')))}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }